<div class="product-add-to-cart-animation-object animated">
  <div [ngStyle]="{ 'width.px': imageWidth, 'height.px': imageHeight }">
    @if (image) {
      <img [src]="getProductImage()" alt="" />
    }
  </div>
</div>
